import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import "../styles/Navbar.css"; // Make sure this matches your actual path

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
      setIsOpen(false);
    }
  };

  const menuItems = [
    { name: "Home", id: "home" },
    { name: "Services", id: "services" },
    { name: "Industry Services", id: "industryservices" },
    { name: "On-Site Support", id: "onsitesupport" },
    { name: "Leadership Team", id: "leadershipteam" },
    { name: "Contact", id: "contactform" },
  ];

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-content">
        <div id="logo">
          <img src="/assets/Logos/logo.png" alt="RK Automation Logo" />
        </div>

        <div className="nav-links">
          {menuItems.map((item) => (
            <button key={item.id} className="nav-btn" onClick={() => handleScrollTo(item.id)}>
              {item.name}
            </button>
          ))}
        </div>

        <button className="menu-btn" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
          {menuItems.map((item) => (
            <button key={item.id} className="mobile-link" onClick={() => handleScrollTo(item.id)}>
              {item.name}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
